import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['languageSelect']

  initialize() {
    $(this.languageSelectTarget).select2()
  }
}
